import { crudController } from 'fc-controller'

import {
  URL,
  MODEL,
} from 'fc-model-layers'

// Initialze
import initialize from './initialize'

// Controller
export default function ({tree, branch, token$}) {
  return crudController({
    url: URL,
    model: MODEL,
    tree,
    branch,
    token$,
    initialize,
  })
}
